import { queryOptions } from '@tanstack/react-query';
import { donedealServicesGateway } from '../../../api/api-utils/commonApiUtils';
import { dealerDirectoryQuickLinksSchema } from '../../../api/types/dealerDirectorySeo.typed';

export const dealerDirectoryQuickLinks = (
  county: string | null | undefined,
  franchise: string | null | undefined,
) =>
  queryOptions({
    queryKey: getDealerDirectoryQuickLinksQueryKey(county, franchise),
    queryFn: () => fetchDealerDirectoryQuickLinks(county, franchise),
    staleTime: Infinity,
  });

const getDealerDirectoryQuickLinksQueryKey = (
  county: string | null | undefined,
  franchise: string | null | undefined,
) =>
  [
    'ddapi',
    'v1',
    'seo',
    'dealer-directory',
    mapPathParams(county, franchise) || 'default',
  ] as const;

const fetchDealerDirectoryQuickLinks = async (
  county: string | null | undefined,
  franchise: string | null | undefined,
) => {
  const pathSuffix = mapPathParams(county, franchise);
  const { data } = await donedealServicesGateway.get(
    `/ddapi/v1/seo/dealer-directory${pathSuffix}`,
  );
  return dealerDirectoryQuickLinksSchema.parse(data);
};
/**
 * Maps the county and franchise to the path params. If both are provided, return an empty string.
 * @param county
 * @param franchise
 * @returns The path params string in the format of /county/<county>, /franchise/<franchise> or an empty string if both are provided.
 */
const mapPathParams = (
  county: string | null | undefined,
  franchise: string | null | undefined,
): string => {
  const segments: string[] = [];
  if (county && franchise) {
    return '';
  }
  if (county) {
    segments.push('county', county);
  }
  if (franchise) {
    segments.push('franchise', franchise);
  }
  return segments.length > 0 ? `/${segments.join('/')}` : '';
};
